import * as yup from 'yup';

export const userSignUpSchema = yup.object().shape({
    name: yup
        .string()
        .required('Full Name is required')
        .min(3, 'Full Name must be at least 3 characters long')
        .max(50, 'Full Name cannot exceed 50 characters'),

    email: yup
        .string()
        .email('Please enter a valid email address')
        .required('Email is required'),

    password: yup
        .string()
        .min(8, 'Password must be at least 8 characters long')
        .required('Password is required')
        .matches(/[A-Z]/, 'Password must contain at least one uppercase letter') // At least one uppercase
        .matches(/[0-9]/, 'Password must contain at least one number') // At least one number
        .matches(/[@$!%*?&]/, 'Password must contain at least one special character'), // At least one special character

    confirm_password: yup
        .string()
        .oneOf([yup.ref('password'), null], 'Passwords must match')
        .required('Confirm Password is required'),

    ss_number: yup
        .string()
        .required('Social Security Number is required'),

    about: yup
        .string()
        .max(300, 'About Yourself cannot exceed 300 characters')
        .notRequired(),

    profile: yup
        .mixed()
        .required('Profile Picture is required')
        .test('fileSize', 'File size is too large', (value) => {
            return value && value.size <= 5 * 1024 * 1024;
        })
        .test('fileType', 'Unsupported file format', (value) => {
            return value && ['image/jpeg', 'image/png', 'image/jpg'].includes(value.type);
        }),
});